// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__l4Rdi","track":"Slider_track__2W1E8","rail":"Slider_rail__3jUeS","thumb":"Slider_thumb__3c-Ov"};